import React from 'react';

import { EtatDto } from 'lib_api/lib/api/gen';

import { useApi } from 'hooks/ApiStoreContext';
import { useSubmitReferentielForm } from 'hooks/referentiels/useSubmitReferentielForm';
import { useValidateReferentielForm } from 'hooks/referentiels/useValidateReferentielForm';

import { EtatFormField, EtatFormValue } from '../types';
import { buildDefaultUpdateFormValues, buildDto } from '../utils';

import ModalEdition from './ModalEdition';

interface ModalUpdateProps {
  etat: EtatDto;
  close: () => void;
  visible: boolean;
  refreshDashboard: () => void;
}

export default function ModalUpdate({
  etat,
  close,
  visible,
  refreshDashboard,
}: ModalUpdateProps): React.ReactElement {
  const initials: EtatFormValue = buildDefaultUpdateFormValues(etat);
  const { AdminFonctionnelControllerApi } = useApi();
  const { submit, inProgress } = useSubmitReferentielForm(
    refreshDashboard,
    close,
    (values: EtatFormValue) =>
      AdminFonctionnelControllerApi.updateEtatUsingPUT(
        etat.idCorrelation,
        buildDto(values),
      ),
  );
  const { validate } = useValidateReferentielForm(
    (field: EtatFormField, values: EtatFormValue) =>
      AdminFonctionnelControllerApi.validateUpdateEtatFieldUsingPOST(
        field,
        etat.idCorrelation,
        buildDto(values),
      ),
    response => response.etatViolationsDto ?? [],
  );

  return (
    <ModalEdition
      close={close}
      visible={visible}
      title="Mise à jour de l'état"
      initials={initials}
      isSubmitting={inProgress}
      submit={submit}
      validate={validate}
    />
  );
}
